import React, { Component } from "react";
import {  FormGroup, CardHeader, Media, Input, Modal } from "reactstrap";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,

} from "@themesberg/react-bootstrap";
import "@pathofdev/react-tag-input/build/index.css";
import SpinDiv from "../../components/SpinDiv";
import "antd/dist/antd.css";
import { toast } from "react-toastify";
import moment from "moment";
import ReactDatetime from "react-datetime";
import {faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Rate } from 'antd';
import {addDepartmentPerformance,getPerformancesDepartments, getDepartmentalPerformance} from "../../../services/departmentPerformanceService"

const desc = ['Terrible', 'Bad', 'Normal', 'Good', 'Wonderful'];

export class AddAdministrative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //appearance:3,
      teamwork:3,
      customer_conversion_rate:3,
      response_time:3,
      service_knowledge:3,
      department_name:'Administrative',
      customer_service_satisfaction:3,
      department:props.department,
      department_id:props.department.id,
      employees:[]
    };
  }
  onChange = (e, state) => {
    this.setState({[state]: e });
  };

  componentDidMount() {
    this.searchDepartments();
  }

  showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };

  searchDepartments = () => {
    this.setState({ loading: true });
    const {department_name}=this.state;
  
    getPerformancesDepartments({department_name}).then(
      
      (res) => {
        this.setState({
          //departments: res.departments,
          employees:res.employees,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };
 


  onSaveAdministrative = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const {teamwork,
      customer_conversion_rate,
      response_time,
      service_knowledge,
      customer_service_satisfaction,
      week,
      employee_id,
      department_id,date, validation } = this.state;
    await this.setState({
      validation: {
        ...validation,
        teamwork: teamwork !== '' && teamwork !== undefined,
        employee_id: employee_id !== '' && employee_id !== undefined,
        customer_service_satisfaction: customer_service_satisfaction !== '' && customer_service_satisfaction !== undefined,
        response_time: response_time !== '' && response_time !== undefined,
        service_knowledge: service_knowledge !== '' && service_knowledge !== undefined,
        customer_service_satisfaction: customer_service_satisfaction !== '' && customer_service_satisfaction !== undefined,
        week: week !== '' && week !== undefined,
        department_id: department_id !== '' && department_id !== undefined,
        date: date !== '' && date !== undefined,
        
        
      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.saveAdministrative();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });

      toast(
        <div style={{ padding: "10px 20px" }}>
          <p style={{ margin: 0, fontWeight: "bold", color: "red" }}>Errors:</p>
          {errors.map((v) => (
            <p key={v} style={{ margin: 0, fontSize: 14, color: "red" }}>
              * {this.validationRules(v)}
            </p>
          ))}
        </div>
      )
    }
  };


  validationRules = (field) => {
    if (field == 'response_time') {
      return "Response Time is required"
    } else if (field == 'service_knowledge') {
      return "Service Knowledge Field is required"
    } else if (field == 'teamwork') {
      return "Team Work rating is required"
    }else if (field == 'customer_conversion_rate') {
      return "Customer Conversion Field rating is required"
    }else if(field === "date"){
      return "Date  is required";
    }else if(field === "service_knowledge"){
      return "Service Knowoledge is required";
    }else if(field === "employee_id"){
      return "Employee is required";
    }else if(field === "week"){
      return "Week is required";
    }
  };

  dateFilter = async (e, state) => {
    await this.setState({ [state]: e })

  }

  saveAdministrative= () => {
    this.setState({ saving: true });
    const {teamwork,
      employee_id,
      customer_conversion_rate,
      response_time,
      service_knowledge,
      customer_service_satisfaction,
      week,
      department_id,date} = this.state;
      let year= moment(date,"MMM, YYYY").year()
      let month = moment(date,"MMM, YYYY").month()+1;
    addDepartmentPerformance({
      department_id: department_id,
      employee_id:employee_id,
      customer_conversion_rate: customer_conversion_rate,
      teamwork: teamwork,
      customer_service_satisfaction: customer_service_satisfaction,
      response_time: response_time,
      service_knowledge: service_knowledge,
      week: week,
      year: year,
      month: month,


    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Performance Saved Suceesfully");
      },
      (err) => {

        if (err) {
          toast.dismiss();
          toast.configure({ hideProgressBar: true, closeButton: false });
          if (err) {
            this.showToastError('An error occured')
          }
          this.setState({ saving: false });
        }
        this.setState({ loading: false });
      }
    );
  };

  showToast = (msg) => {
    toast(<div style={{ padding: 20 }}>{msg}</div>);
  };


  render() {
    const {toggle } = this.props;

    const { saving,loading,department, teamwork,
      employees,
      customer_conversion_rate,
      response_time,
      service_knowledge,
      customer_service_satisfaction,
    } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-top"
          isOpen={department != null}
          toggle={() => !loading && !saving && toggle}
          style={{ maxWidth:800, }}
        >
          {loading && <SpinDiv text={"loading..."} />}
          {saving && <SpinDiv text={"Saving..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            <div className="btn-toolbar mb-2 mb-md-0">
              <h5> Create {department.name} Performance </h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
              <Row>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Employees</Form.Label>

                    <Form.Select
                      id="state"
                      required
                     
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "employee_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Choose Employee</option>
                      {employees.length == 0 && <option value="">loading</option>}
                      {employees.map((p, index) => (
                        <option value={p.user_id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
                  <Col md={6} >
                    <Form.Group className="mb-2">
                      <Form.Label>Week</Form.Label>

                      <Form.Select
                        id="state"
                        required
                      
                        onChange={async (e) => {
                          await this.onChange(e.target.value, "week");
                        }}
                        style={{
                          marginRight: 10,
                          width: "100%",
                        }}
                      >

                        <option value="">Choose Week</option>
                        <option value="1">Week 1</option>
                        <option value="2">Week 2</option>
                        <option value="3">Week 3</option>
                        <option value="4">Week 4</option>
                        
                      </Form.Select>
                    </Form.Group>

                  </Col>
                  
                </Row>
                <Row>
                
      
                <Col md={6} className="mb-3">
                    <Form.Label>Customer Conversion Rate</Form.Label>
                    <h5>
                        <Rate style={{color:'green'}} tooltips={desc}  onChange={e=>this.onChange(e, 'customer_conversion_rate')}  value={customer_conversion_rate} />
                        {customer_conversion_rate ? <span  className="ant-rate-text">{desc[customer_conversion_rate - 1]}</span> : ''}
                    </h5>
                    </Col>
                    <Col md={6} className="mb-3">
                    <Form.Label>Team Work</Form.Label>
                    <h5>
                        <Rate style={{color:'green'}} tooltips={desc} onChange={e=>this.onChange(e, 'teamwork')} value={teamwork} />
                        {teamwork ? <span className="ant-rate-text">{desc[teamwork - 1]}</span> : ''}
                    </h5>
                    </Col>
                </Row>
                
                <Row style={{paddingTop:10}}>
                    
                    <Col md={6} className="mb-3">
                    <Form.Label>Response Time</Form.Label>
                    <h5>
                        <Rate style={{color:'green'}} tooltips={desc} onChange={e=>this.onChange(e, 'response_time')} value={response_time} />
                        {response_time ? <span className="ant-rate-text">{desc[response_time - 1]}</span> : ''}
                    </h5>
                    </Col>
                    <Col md={6} className="mb-3">
                    <Form.Label>Service Knowoledge</Form.Label>
                    <h5>
                        <Rate style={{color:'green'}} tooltips={desc} onChange={e=>this.onChange(e, 'service_knowledge')} value={service_knowledge} />
                        {service_knowledge ? <span className="ant-rate-text">{desc[service_knowledge - 1]}</span> : ''}
                    </h5>
                    </Col>
                </Row>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Label>Customer Service</Form.Label>
                      <h5>
                          <Rate style={{color:'green'}} tooltips={desc} onChange={e=>this.onChange(e, 'customer_service_satisfaction')} value={customer_service_satisfaction} />
                          {customer_service_satisfaction ? <span className="ant-rate-text">{desc[customer_service_satisfaction - 1]}</span> : ''}
                      </h5>
                    </Col>
                    <Col md={6} className="mb-3">
                    <Form.Group id="date">
                      <Form.Label>Date</Form.Label>
                      <ReactDatetime
                              
                        dateFormat={'MMM, YYYY'}
                        closeOnSelect
                        onChange={e=>this.dateFilter(e, 'date')}
                        inputProps={{
                          required: true,
                          className: 'form-control date-width'
                        }}
                        timeFormat={false}
                      />
                    </Form.Group>
                  </Col>
                
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <Col md={12}>
                    <div>
                      <Button
                        variant="primary"
                        size="sm"
                        style={{ marginTop: "10px", float: "right" }}
                        disabled={saving}
                        onClick={this.onSaveAdministrative}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        variant="transparent"
                        data-dismiss="modal"
                        type="button"
                        disabled={saving}
                        style={{ marginTop: "10px", float: "right" }}
                        onClick={toggle}
                      >
                        {" "}
                        Close
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Modal>
      </>
    );
  }

}
export default AddAdministrative;
